<div class="row d-flex flex-column flex-sm-row">
  <div
    *ngFor="let metric of selectedMetrics | slice:0:secondLineStartIndex; index as idx"
    class="mb-4 dashboard-card-summary__card-wrapper dashboard-card-summary__card-wrapper--first-line"
  >
    <app-mini-chart
      [label]="getSafeLabel(metric)"
      [isCurrency]="smallChartStatsMap[metric].isCurrency"
      [isPercentage]="smallChartStatsMap[metric].isPercentage || false"
      [data]="series?.[metric]?.values | appFakeSeriesIfEmpty"
      [total]="statsTotalData?.[metric]"
      [availableMetrics]="getAvailableMetrics()"
      [isSelected]="isSelected(idx)"
      [isFakeData]="!series?.[metric]?.values?.length"
      class="cursor-pointer"
      chartHeight="30px"
      (selectMetric)="onSelectMetric(idx, $event)"
      (click)="onSelectChart(idx)"
      [pallete]="getChartPalette(idx)"
    ></app-mini-chart>
  </div>

  <div
    *ngFor="let metric of selectedMetrics | slice:secondLineStartIndex:secondLineEndIndex; index as idx"
    class="dashboard-card-summary__card-wrapper dashboard-card-summary__card-wrapper--second-line"
  >
    <app-mini-chart
      [label]="getSafeLabel(metric)"
      [isCurrency]="smallChartStatsMap[metric].isCurrency"
      [isPercentage]="smallChartStatsMap[metric].isPercentage || false"
      [data]="series?.[metric]?.values | appFakeSeriesIfEmpty"
      [total]="statsTotalData?.[metric]"
      [availableMetrics]="getAvailableMetrics()"
      [isSelected]="isSelected(idx + secondLineStartIndex)"
      [isFakeData]="!series?.[metric]?.values?.length"
      class="cursor-pointer"
      chartHeight="30px"
      (selectMetric)="onSelectMetric(idx + secondLineStartIndex, $event)"
      (click)="onSelectChart(idx + secondLineStartIndex)"
      [pallete]="getChartPalette(idx + secondLineStartIndex)"
    ></app-mini-chart>
  </div>
</div>
